import { render, staticRenderFns } from "./EventListReg2.vue?vue&type=template&id=07dc75cf"
import script from "./EventListReg2.vue?vue&type=script&lang=js"
export * from "./EventListReg2.vue?vue&type=script&lang=js"
import style0 from "./EventListReg2.vue?vue&type=style&index=0&id=07dc75cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports